import { getActiveProductId } from '@/utils/productAccess';
import type { ProductId } from '@/config/products';
import {
  isOrgConsolePath,
  isPlanProductPath,
  isSatelliteProductPath,
} from '@/utils/orgConsole';
import { isAllowedWithoutProductLicense } from '@/utils/productLicense';

/** Routes that require an assigned seat for the active product. */
export function isProductLicensedPath(pathname: string, search = ''): boolean {
  if (isAllowedWithoutProductLicense(pathname)) return false;
  if (isOrgConsolePath(pathname)) return false;
  if (pathname.startsWith('/workspace')) return true;
  return isPlanProductPath(pathname) || isSatelliteProductPath(pathname);
}

export function getRequiredProductForPath(pathname: string, search = ''): ProductId {
  return getActiveProductId(pathname, search);
}
